import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import Button from "../Button";
import ChevronLeft from "../icons/ChevronLeft";
import getSpacingToken from "../common/getSpacingToken";
import useTranslate from "../hooks/useTranslate";
var StyledBreadcrumbs = styled.nav.withConfig({
  displayName: "Breadcrumbs__StyledBreadcrumbs",
  componentId: "sc-1zqkwq-0"
})(["font-family:", ";font-size:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontSizeTextSmall;
}, getSpacingToken);
StyledBreadcrumbs.defaultProps = {
  theme: defaultTheme
};
var StyledBreadcrumbsList = styled.ol.withConfig({
  displayName: "Breadcrumbs__StyledBreadcrumbsList",
  componentId: "sc-1zqkwq-1"
})(["display:flex;flex-wrap:wrap;list-style:none;margin:0;padding:0;"]);
var StyledBackButtonWrapper = styled.span.withConfig({
  displayName: "Breadcrumbs__StyledBackButtonWrapper",
  componentId: "sc-1zqkwq-2"
})(["margin-right:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.spaceSmall;
});
StyledBackButtonWrapper.defaultProps = {
  theme: defaultTheme
};

var GoBackButton = function GoBackButton(_ref4) {
  var onClick = _ref4.onClick;
  var translate = useTranslate();
  return React.createElement(StyledBackButtonWrapper, null, React.createElement(Button, {
    iconLeft: React.createElement(ChevronLeft, null),
    circled: true,
    type: "secondary",
    size: "small",
    onClick: onClick,
    title: translate("breadcrumbs_back")
  }));
};

var Breadcrumbs = function Breadcrumbs(_ref5) {
  var children = _ref5.children,
      dataTest = _ref5.dataTest,
      onGoBack = _ref5.onGoBack,
      spaceAfter = _ref5.spaceAfter;
  return React.createElement(StyledBreadcrumbs, {
    "aria-label": "Breadcrumb",
    role: "navigation",
    "data-test": dataTest,
    spaceAfter: spaceAfter
  }, React.createElement(StyledBreadcrumbsList, {
    vocab: "http://schema.org/",
    typeof: "BreadcrumbList"
  }, onGoBack && React.createElement(GoBackButton, {
    onClick: onGoBack
  }), React.Children.map(children, function (item, key) {
    return React.cloneElement(item, {
      active: key === React.Children.count(children) - 1,
      contentKey: key + 1
    });
  })));
};

export default Breadcrumbs;
export { default as BreadcrumbsItem } from "./BreadcrumbsItem";